import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api, inr, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Plus, Minus } from "lucide-react";

export default function Cart() {
  const { cart, removeFromCart, updateQty, user } = useAuth();
  const nav = useNavigate();
  const subtotal = cart.reduce((s, c) => s + c.price * c.quantity, 0);
  const shipping = subtotal >= 3000 || subtotal === 0 ? 0 : 150;
  const tax = subtotal * 0.05;
  const total = subtotal + tax + shipping;

  if (cart.length === 0) return (
    <div className="max-w-3xl mx-auto text-center py-32 px-4">
      <div className="overline mb-3">Your Bag</div>
      <h1 className="h2-editorial mb-4">Your bag is quiet.</h1>
      <p className="text-neutral-600 mb-6">Discover pieces woven with story and soul.</p>
      <Link to="/shop" className="btn-silk">Explore Collections</Link>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10">
      <h1 className="h1-editorial mb-8">Your Bag</h1>
      <div className="grid lg:grid-cols-[1fr_360px] gap-10">
        <div className="space-y-4">
          {cart.map(item => (
            <div key={item.product_id} className="flex gap-4 border-b pb-4" data-testid={`cart-item-${item.product_id}`}>
              <img src={fileUrl(item.image)} className="w-24 h-32 object-cover bg-neutral-100"/>
              <div className="flex-1">
                <Link to={`/product/${item.slug}`} className="font-serif text-lg hover:text-[#0E4D34]">{item.name}</Link>
                <div className="text-sm text-[#0E4D34] font-semibold mt-1">{inr(item.price)}</div>
                <div className="flex items-center gap-3 mt-3">
                  <button onClick={() => updateQty(item.product_id, item.quantity - 1)} className="p-1 border"><Minus size={12}/></button>
                  <span className="text-sm w-8 text-center">{item.quantity}</span>
                  <button onClick={() => updateQty(item.product_id, item.quantity + 1)} className="p-1 border"><Plus size={12}/></button>
                  <button onClick={() => removeFromCart(item.product_id)} data-testid={`remove-${item.product_id}`} className="ml-4 text-[#991B1B] p-1"><Trash2 size={14}/></button>
                </div>
              </div>
              <div className="text-right font-semibold text-[#0E4D34]">{inr(item.price * item.quantity)}</div>
            </div>
          ))}
        </div>
        <aside className="bg-white border border-neutral-200 p-6 h-fit sticky top-28">
          <h3 className="font-serif text-2xl mb-4">Order Summary</h3>
          <div className="space-y-2 text-sm mb-4">
            <div className="flex justify-between"><span>Subtotal</span><span>{inr(subtotal)}</span></div>
            <div className="flex justify-between"><span>GST (5%)</span><span>{inr(tax)}</span></div>
            <div className="flex justify-between"><span>Shipping</span><span>{shipping === 0 ? "Free" : inr(shipping)}</span></div>
            <div className="flex justify-between font-bold text-base border-t pt-2 mt-2 text-[#0E4D34]"><span>Total</span><span>{inr(total)}</span></div>
          </div>
          <button onClick={() => user ? nav("/checkout") : nav("/login?redirect=/checkout")} data-testid="btn-checkout" className="btn-silk w-full">Proceed to Checkout</button>
          <Link to="/shop" className="block text-center mt-3 text-xs uppercase tracking-widest text-neutral-500 hover:text-[#0E4D34]">Continue Shopping</Link>
        </aside>
      </div>
    </div>
  );
}
